var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider"},[(_vm.title)?_c('z-caption',{staticClass:"divider__title",attrs:{"tag":"p"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_vm._v(" "),(!!this.$slots.default)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }